import React from 'react';
import Callout from '../sitePages/Callout';

type PageHeaderProps = {
  title: string;
  description: string;
  information?: string;
  warning?: string;
  descriptionClass?: string;
  isRenewalLandingPage?: boolean;
};

const PageHeader = ({
  title,
  description,
  descriptionClass,
  information,
  warning,
  isRenewalLandingPage
}: PageHeaderProps): JSX.Element => {
  const getTitle = (isRenewalTitlePage: boolean) => {
    return isRenewalTitlePage ? (
      <h1 data-testid='page-title' className='m2-bottom lp-header cms'>
        {title}
      </h1>
    ) : (
      <h3 data-testid='page-title' className='cms'>
        {title}
      </h3>
    );
  };

  return (
    <>
      {getTitle(isRenewalLandingPage ?? false)}
      <p
        data-testid='page-description'
        className={`m1-bottom cms ${descriptionClass}`}>
        {description}
      </p>
      {information && <Callout text={information} />}
      {warning && <Callout text={warning} isWarning={true} />}
    </>
  );
};

export default PageHeader;
